<div class="main-container lg-view" *ngIf="!isLoading">
	<h3>Thread</h3>

	<div class="main-form">

		<form *ngIf="routePayload?.jobs?.length > 1" [formGroup]="formModel">
			<mat-form-field>
				<mat-select formControlName="selectedJob">
					<mat-option *ngFor="let job of routePayload.jobs" [value]="job">
						{{moment(job.jobEta).parseZone().format('MM/DD/YYYY') + ' - ' + job.name}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</form>

		<div class="empty-message-container" *ngIf="!comments?.length">There are no items yet!</div>

		<ng-container *ngIf="comments.length">
			<div class="note-container" [class.message-tip-left]="note.isWrittenByStaff"
				[class.message-tip-right]="!note.isWrittenByStaff" *ngFor="let note of comments">
				<p class="note-subject" *ngIf="note.subject"><span>{{ note.subject }}</span></p>
				<p class="note-description" *ngIf="note.description"><span>{{ note.description }}</span></p>
				<p class="note-metadata">
					<span class="note-metadata-author">by {{ note.createdByName }}</span>
					<span class="note-metadata-date">on {{ moment.parseZone(note.createdOn).format('MM/DD/YYYY hh:mm A')
						}}</span>
				</p>
				<div class="note-actions-container"
					*ngIf="note.isWrittenByStaff && formModel.get('selectedJob').value.isCurrentJob">
					<button mat-button (click)="reply(note)">Reply</button>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<div class="actions-container  md-view" *ngIf="!isLoading">
	<ng-container *ngIf="!customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'"></action-button>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>

</div>